// Lifestyle imagery is decorative only. Product photography always comes from Square.
export const LIFESTYLE = {
  hero: "https://images.unsplash.com/photo-1645871302770-fa6c882a8e2b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900",
  honey: "https://images.unsplash.com/photo-1645871363531-ccffefade538?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  teaRitual: "https://images.unsplash.com/photo-1675155337816-5002bb718d73?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  teaPour: "https://images.unsplash.com/photo-1611312410928-bdcb480e6239?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  selfCare: "https://images.unsplash.com/photo-1731760430954-735db4766b0e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  bodyOil: "https://images.unsplash.com/photo-1648587385042-b5e2d3965bc0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  family: "https://images.unsplash.com/photo-1602255680702-c47261041a97?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cozy: "https://images.unsplash.com/photo-1632927126546-e3e051a0ba6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  candle: "https://images.unsplash.com/photo-1640095889747-2090ee12fa7d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  relax: "https://images.unsplash.com/photo-1713865472921-25487ad6028f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const CATEGORIES = [
  { slug: "honey", label: "Honey", tagline: "Raw, whipped, creamed & Manuka" },
  { slug: "tea", label: "Loose-Leaf Tea", tagline: "Four small-batch blends" },
  { slug: "body-care", label: "Body Care", tagline: "JASAY Botanica rituals" },
  { slug: "oils-personal-care", label: "Oils & Personal Care", tagline: "Botanical golden oils" },
  { slug: "gift-sets", label: "Gift Sets", tagline: "Curated to give" },
  { slug: "wellness-rituals", label: "Wellness Rituals", tagline: "Simple daily moments" },
];

// Curated collections reference REAL products by slug. No fake Square products.
export const GIFT_SETS = [
  {
    id: "honey-flight",
    title: "The Honey Flight",
    blurb: "A trio of our most-loved raw and infused honeys — a warm welcome to the pantry.",
    slugs: ["raw-organic-honey-8-oz", "vanilla-bean-raw-honey", "cinnamon-vanilla-raw-honey"],
  },
  {
    id: "tea-ritual",
    title: "Tea Lover's Ritual",
    blurb: "All four loose-leaf blends, for hot mornings and slow iced afternoons.",
    slugs: ["mango-gold", "royale-tropical-loose-leaf-black-tea", "wild-berry", "pomegranate-silk"],
  },
  {
    id: "self-care",
    title: "Restorative Self-Care",
    blurb: "Golden botanical oils from JASAY Botanica for a quiet evening ritual.",
    slugs: ["saffron-rose-infused-jojoba-oil-2-oz", "100-organic-golden-jojoba-oil-2-oz"],
  },
  {
    id: "manuka-wellness",
    title: "The Golden Wellness Set",
    blurb: "Documented Manuka honey MGO 234+ paired with a creamy whipped honey.",
    slugs: ["authentic-new-zealand-manuka-honey-mgo-234", "vanilla-bean-whipped-honey"],
  },
];

export const RITUALS = [
  {
    id: "morning-cup",
    number: "01",
    title: "The Morning Cup",
    body: "Warm the pot, measure a spoon of loose leaves, and let the steam rise. A few unhurried minutes before the day begins.",
    slug: "tea",
    image: "teaRitual",
  },
  {
    id: "golden-spoon",
    number: "02",
    title: "The Golden Spoon",
    body: "A spoonful of raw or Manuka honey MGO 234+ stirred into tea, drizzled over yogurt, or simply enjoyed straight from the jar.",
    slug: "honey",
    image: "honey",
  },
  {
    id: "evening-unwind",
    number: "03",
    title: "The Evening Unwind",
    body: "Warm a few drops of golden jojoba oil between your palms and take a slow breath. A gentle close to a full day.",
    slug: "body-care",
    image: "bodyOil",
  },
];

export const STORY_CHAPTERS = [
  {
    number: "01",
    title: "A family table",
    body: "Washington Family Provisions began at a family table in Northern California — a belief that the small things we make and share at home are worth doing beautifully.",
  },
  {
    number: "02",
    title: "Made in small batches",
    body: "We prepare our honey, teas, and botanical oils in small batches with thoughtfully selected ingredients, so each jar and pouch feels considered rather than mass-produced.",
  },
  {
    number: "03",
    title: "Everyday luxury",
    body: "From documented Manuka honey MGO 234+ to our JASAY Botanica oils, we bring a quiet sense of everyday luxury to the kitchen and the self-care shelf alike.",
  },
];

export const QUALITY_STANDARDS = [
  { title: "Small-batch made", body: "Prepared in thoughtful batches, never mass-produced." },
  { title: "Quality ingredients", body: "Thoughtfully selected, natural-feeling ingredients." },
  { title: "Documented Manuka MGO 234+", body: "Authentic New Zealand Manuka honey with a documented rating." },
  { title: "Rooted in California", body: "Family-owned and prepared in Stockton, California." },
];

export const BUSINESS = {
  name: "Washington Family Provisions",
  email: "cs@washingtonfamilyprovisions.com",
  phone: "+1 209-747-9235",
  address: "Northern California",
  instagram: "https://www.instagram.com/wasingtonfamilyprovisions",
  facebook: "https://www.facebook.com/people/Washington-Family-Provisions/61591847886600/",
};

// Manuka education — compliant, no medical claims.
export const MANUKA_BENEFITS = [
  { icon: "Award", title: "What MGO 234+ Represents", short: "A measured grade marker — this honey is rated MGO 234+.", detail: "MGO is a measured marker used to grade Manuka honey. This product is documented at MGO 234+ — a clear, comparable number rather than a vague promise." },
  { icon: "FlaskConical", title: "Naturally Occurring Methylglyoxal", short: "The compound MGO grading measures, present in Manuka.", detail: "MGO stands for methylglyoxal, a compound that occurs naturally in Manuka honey. Manuka honey has been studied for its naturally occurring compounds and distinctive properties." },
  { icon: "Globe", title: "Distinctive Taste & Premium Origin", short: "Authentic New Zealand Manuka — rich, malty depth.", detail: "Sourced from New Zealand, Manuka honey has a fuller, more complex character than everyday honey, with a naturally rich and malty depth." },
  { icon: "Sunrise", title: "Everyday Wellness Rituals", short: "A simple spoonful as part of a calm daily routine.", detail: "Many people enjoy a spoonful as a small, comforting moment in their day — a simple ritual to slow down and savour." },
  { icon: "Utensils", title: "Tea, Toast & Yogurt", short: "Stir into tea or drizzle over toast, yogurt, or oatmeal.", detail: "Manuka honey is lovely stirred into tea, drizzled over toast, yogurt, or oatmeal, or added to dressings for natural sweetness." },
  { icon: "Sparkles", title: "Simple Beauty & Self-Care", short: "A small amount can be part of gentle self-care rituals.", detail: "A small amount of honey can be part of gentle, at-home self-care rituals you enjoy at your own pace." },
  { icon: "ShieldCheck", title: "Batch Testing & Documentation", short: "Graded and documented — MGO 234+ means what it says.", detail: "Our Manuka honey is graded and documented so the MGO 234+ rating is transparent and verifiable." },
  { icon: "Archive", title: "How to Store & Enjoy", short: "Keep sealed at room temperature.", detail: "Store sealed at room temperature away from direct heat. Natural crystallizing or texture changes are normal and do not mean the honey has spoiled." },
];

export const TRUST_SIGNALS = [
  { icon: "Home", title: "Family-owned", text: "A family-rooted brand, made in small batches." },
  { icon: "Lock", title: "Secure Square checkout", text: "Payments handled securely by Square." },
  { icon: "Camera", title: "Real product photography", text: "Every product shown is our own, never stock imagery." },
  { icon: "Leaf", title: "Transparent ingredients", text: "Clear directions and storage on every product." },
  { icon: "Award", title: "Documented MGO 234+", text: "Manuka honey graded and documented." },
  { icon: "Truck", title: "Clear shipping & returns", text: "Honest policies and responsive support." },
];

// Product-type helper copy (only honest, type-level info; shown where relevant).
export const PRODUCT_INFO = {
  honey: {
    directions: "Enjoy by the spoonful, stir into tea, or drizzle over toast, yogurt, and oatmeal.",
    storage: "Store sealed at room temperature away from direct heat. Natural crystallizing is normal.",
    shipping: "Ships within the U.S. · Typically processed in 2–4 business days.",
  },
  tea: {
    directions: "Steep about 1 tsp of loose leaves per cup in hot water for 3–5 minutes. Enjoy hot or over ice.",
    storage: "Store in a cool, dry place away from direct sunlight, sealed to keep fresh.",
    shipping: "Ships within the U.S. · Typically processed in 2–4 business days.",
  },
  "oils-personal-care": {
    directions: "Warm a few drops between your palms and massage gently into skin. For external use only.",
    storage: "Store in a cool, dry place away from direct sunlight.",
    shipping: "Ships within the U.S. · Typically processed in 2–4 business days.",
  },
  "body-care": {
    directions: "Warm a few drops between your palms and massage gently into skin. For external use only.",
    storage: "Store in a cool, dry place away from direct sunlight.",
    shipping: "Ships within the U.S. · Typically processed in 2–4 business days.",
  },
};

export const QUIZ_QUESTIONS = [
  {
    id: "need",
    q: "What are you hoping to make more room for?",
    options: [
      { value: "rest", label: "Rest and relaxation" },
      { value: "ritual", label: "A comforting daily ritual" },
      { value: "care", label: "Personal care and nourishment" },
      { value: "energy", label: "Energy and focus" },
      { value: "gift", label: "A thoughtful gift" },
    ],
  },
  {
    id: "experience",
    q: "Which experience sounds most appealing?",
    options: [
      { value: "tea", label: "A warm cup of loose-leaf tea" },
      { value: "honey", label: "A spoonful of premium honey" },
      { value: "body", label: "A calming body-care ritual" },
      { value: "set", label: "A complete wellness set" },
    ],
  },
  {
    id: "sensory",
    q: "Which sensory direction fits you best?",
    options: [
      { value: "floral", label: "Soft and floral" },
      { value: "warm", label: "Warm and comforting" },
      { value: "fresh", label: "Fresh and uplifting" },
      { value: "rich", label: "Rich and indulgent" },
    ],
  },
  {
    id: "audience",
    q: "Who are you shopping for?",
    options: [
      { value: "myself", label: "Myself" },
      { value: "someone", label: "Someone special" },
      { value: "exploring", label: "I am still exploring" },
    ],
  },
];

export const ARCHETYPES = {
  "rest-seeker": {
    title: "The Rest Seeker",
    blurb: "You’re making space to slow down and breathe. These calming picks are made for quiet, unhurried moments.",
    slugs: ["saffron-rose-infused-jojoba-oil-2-oz", "100-organic-golden-jojoba-oil-2-oz", "wild-berry"],
  },
  "mindful-ritualist": {
    title: "The Mindful Ritualist",
    blurb: "You love a comforting daily ritual. A warm, considered cup is your kind of pause.",
    slugs: ["mango-gold", "royale-tropical-loose-leaf-black-tea", "pomegranate-silk"],
  },
  "comfort-curator": {
    title: "The Comfort Curator",
    blurb: "You care for yourself and your people with warmth. These nourishing favourites feel like home.",
    slugs: ["cinnamon-vanilla-raw-honey", "vanilla-bean-whipped-honey", "100-organic-golden-jojoba-oil-2-oz"],
  },
  "everyday-indulger": {
    title: "The Everyday Indulger",
    blurb: "You savour the good stuff. These rich, spoonable treats turn an ordinary day a little golden.",
    slugs: ["cacao-vanilla-sea-salt-whipped-honey", "peach-mango-creamed-honey", "authentic-new-zealand-manuka-honey-mgo-234"],
  },
  "thoughtful-giver": {
    title: "The Thoughtful Giver",
    blurb: "You give with intention. These make a warm, memorable gift for someone special.",
    slugs: ["authentic-new-zealand-manuka-honey-mgo-234", "royale-tropical-loose-leaf-black-tea", "vanilla-bean-whipped-honey"],
  },
};

export function scoreQuiz(answers) {
  // Gift intent takes priority.
  if (answers.need === "gift" || answers.audience === "someone") return "thoughtful-giver";
  const byExperience = { tea: "mindful-ritualist", honey: "everyday-indulger", body: "rest-seeker", set: "comfort-curator" };
  const byNeed = { rest: "rest-seeker", ritual: "mindful-ritualist", care: "comfort-curator", energy: "mindful-ritualist" };
  return byExperience[answers.experience] || byNeed[answers.need] || "mindful-ritualist";
}
